import React, { useMemo, useState } from "react";
import Modal from "react-modal";

interface ProductDeliveryPriceModalProperties {
    readonly onAfterClose: () => void;
}

export default function ProductDeliveryPriceModal({ onAfterClose }: ProductDeliveryPriceModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = useState(true);

    const externalHTML = useMemo<string | undefined>(() => {
        if (typeof document === "undefined") {
            return;
        }

        const externalElement = document.querySelector<HTMLDivElement>(".js-delivery-information-container");

        return externalElement?.innerHTML;
    }, []);

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            onAfterClose={onAfterClose}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition shop-modal-change"
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="row" dangerouslySetInnerHTML={{ __html: externalHTML ?? "" }}>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
